import { useBaseApiCall } from '@/api/factory/base/api';
import { useHandleMutationError } from '@/api/utils';
import { useMutation } from '@tanstack/react-query';

interface SurveyRequest {
  email?: string;
  answers: SurveyData[];
}

type SurveyData = {
  question: string;
  answer: string | undefined;
};

export const useSendSurvey = () => {
  const mutationFn = useBaseApiCall<null, [SurveyRequest]>((api, data) =>
    api.post('surveys/create', {
      ...data,
    }),
  );
  const handleMutationError = useHandleMutationError();

  return useMutation({
    mutationFn,
    onError: handleMutationError,
  });
};
